import { render, staticRenderFns } from "./FormPlano.vue?vue&type=template&id=44d89c84&"
import script from "./FormPlano.vue?vue&type=script&lang=js&"
export * from "./FormPlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports